import React from 'react';
import Icon from 'react-crypto-icons';

// Custom crypto icon component that handles both react-crypto-icons and custom SVGs
const CryptoIcon = ({ name, size = 16, className = '' }) => {
  // Custom icons that we host locally
  const customIcons = {
    'sui': '/crypto-icons/sui.svg',
    'hype': '/crypto-icons/hype.svg'
  };

  // If it's a custom icon, render as img
  if (customIcons[name?.toLowerCase()]) {
    return (
      <img 
        src={customIcons[name.toLowerCase()]} 
        alt={name}
        width={size}
        height={size}
        className={className}
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
      />
    );
  }

  // Otherwise use react-crypto-icons
  if (name) {
    return <Icon name={name.toLowerCase()} size={size} />;
  }

  // No icon
  return null;
};

export default CryptoIcon;
